// 需要添加表格统计的字段
export const fields = [
  'vehicleNumber',
  'vehicleTagNumber',
  'nextSiteName',
  'sealNumber',
  'loadBagNumber',
  'unLoadBagNumber',
  'errorUnLoadBagNumber',
  'notUnLoadBagNumber',
  'loadPackageNumber',
  'unLoadPackageNumber',
  'errorUnLoadPackageNumber',
  'notUnLoadPackageNumber',
  'sortingPackageNumber',
  'notSortingPackageNumber'
];
// 统计字段
export const fieldToTotalMap = {
  vehicleNumber: 'totalVehicleNumber',
  vehicleTagNumber: 'totalVehicleTagNumber',
  nextSiteName: 'totalNextSiteId', // 请注意: 'nextSiteName' 对应的是 'totalNextSiteId'
  sealNumber: 'totalSealNumber',
  loadBagNumber: 'totalLoadBagNumber',
  unLoadBagNumber: 'totalUnLoadBagNumber',
  errorUnLoadBagNumber: 'totalErrorUnLoadBagNumber',
  notUnLoadBagNumber: 'totalNotUnLoadBagNumber',
  loadPackageNumber: 'totalLoadPackageNumber',
  unLoadPackageNumber: 'totalUnLoadPackageNumber',
  errorUnLoadPackageNumber: 'totalErrorUnLoadPackageNumber',
  notUnLoadPackageNumber: 'totalNotUnLoadPackageNumber',
  sortingPackageNumber: 'totalSortingPackageNumber',
  notSortingPackageNumber: 'totalNotSortingPackageNumber'
};
